import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  UpdateReferralRequestSurveyDocument,
  UpdateReferralRequestSurveyInput,
  UpdateReferralRequestSurveyMutation,
} from '../generated/survey';

const useUpdateReferralRequestSurvey = () =>
  useSecureGraphqlMutation<
    UpdateReferralRequestSurveyMutation,
    { input: UpdateReferralRequestSurveyInput },
    'AttachmentValidationFailed' | 'SurveyNotFound' | 'SurveyResponseConflict'
  >(UpdateReferralRequestSurveyDocument, [
    'AttachmentValidationFailed' as const,
    'SurveyNotFound' as const,
    'SurveyResponseConflict' as const,
  ]);

export { useUpdateReferralRequestSurvey };
